<template>
    <v-dialog v-model="dialogGroup" persistent max-width="550px" max-height= "600px">
      <v-card tile style="border-radius:20px;">
        <v-toolbar card style="background: #1a222c !important;">
          <v-toolbar-title class="white--text CSChatThai">
            <span class="headline CSChatThai">
              <v-icon color="white">group_add</v-icon>&nbsp;&nbsp;{{$t('LeftSide.createGroup.header')}}
            </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog">
            <v-icon style="color: white !important; font-size: 25px !important;">clear</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text style="padding: 0px;">
          <v-stepper v-model="step_creategroup">
            <v-stepper-items>
              <v-stepper-content step="1" style="height: 550px">
                <v-container wrap style="padding-top: 0px;padding-bottom: 10px;">
                  <h4 style="padding-left: 10px;">{{$t('Dialog.group.chooseFriend')}}</h4>
                  <v-layout row wrap>
                    <v-flex sm12 md12 lg12 xl12 class="borderlistfriend">
                      <v-text-field v-model="searchfriend" solo hide-details append-icon="search" :label="$t('LeftSide.createGroup.searching')" clearable style="margin: 7px;"/>
                        <v-list class="CSChatThai widthfull scrolling-wrapper" style="padding: 0px;"  v-if="FilterFriendList.length != 0" >
                          <template v-for="(item, index) in FilterFriendList">
                            <v-list-tile :key="item.tokenuser" avatar ripple >
                              <v-list-tile-avatar>
                                <img  v-if="item.profilepicture"  :src="item.profilepicture" class="alligator-turtle">
                                <img v-else-if="item.type === 'company'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                                <img v-else-if="item.type === 'government'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                                <img v-else-if="item.type === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
                                <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
                              </v-list-tile-avatar>
                              <v-list-tile-content>
                                <v-list-tile-title class="textoverflow">
                                  {{ item.name }}
                                </v-list-tile-title>
                              </v-list-tile-content>
                              <v-list-tile-action>
                                <v-checkbox v-model="selected" :value="item" style="color: #2562af !important;">
                                </v-checkbox>
                              </v-list-tile-action>
                            </v-list-tile>
                            <!-- <v-divider v-if="index + 1 < FriendList.length" :key="index"></v-divider> -->
                          </template>
                        </v-list>
                        <v-container v-else>
                          <v-list>
                            <v-list-tile @click="showDialog('AddFriend')">
                              <v-list-tile-content>
                                <v-list-tile-title class="CSChatThai " style="font-size:12px;text-align:center;color: black;">
                                  <v-icon style="color: black;  font-size: 18px !important;">add_circle</v-icon>
                                  {{$t('AnswerQuestion.addFriend')}}
                                </v-list-tile-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </v-list>
                        </v-container>
                    </v-flex>
                    <v-flex sm12 md12 lg12 xl12 class="borderlistfriendSelect">
                      <div class="setBorder ml-1">
                        <v-layout row wrap class="setPaddingButtomListFriendInGroup" style="margin-top: 5px;">
                          <h4 style="padding-left: 12px;" v-if="selected.length != 0">{{$t('RightSide.member')}} ({{selected.length}})</h4>
                        </v-layout>
                        <div class="scrolling-wrapperx" v-if="selected.length != 0">
                          <v-item-group>
                            <v-item
                              v-for="(i, index) in selected"
                              :key="index"
                            >
                              <v-chip slot-scope="{ active }" :selected="active" close @input="removeListAddGroup(i)">
                                <v-avatar>
                                  <img v-if="i.profilepicture" :src="i.profilepicture" :alt="i.name" class="alligator-turtle">
                                  <img v-else-if="i.type === 'company'" src='/static/img/default_profile/business-white.png' :alt="i.name">
                                  <img v-else-if="i.type === 'government'" src='/static/img/default_profile/business-white.png' :alt="i.name">
                                  <img v-else-if="i.type === 'bot'" src='/static/img/default_profile/bot-white.png' :alt="i.name">
                                  <img v-else src='/static/img/default_profile/man-white.png' :alt="i.name">
                                </v-avatar>
                                {{i.name}}
                              </v-chip>
                            </v-item>
                          </v-item-group>
                        </div>
                        <div v-else style="margin-top: 40px;">
                          <v-layout align-center justify-center fill-height row>
                            <h5>{{$t('LeftSide.createGroup.noneSelect')}}</h5>
                          </v-layout>
                        </div>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-container>
                <v-layout row wrap style="margin-top: 20px;">
                  <v-flex class="text-xs-left">
                    <template>
                      <v-btn @click.native="closeDialog" class="CSChatThai btncanclegroup">{{$t('AnswerQuestion.cancel')}} </v-btn>
                    </template>
                  </v-flex>
                  <v-flex class="text-xs-right">
                    <v-btn color="primary" class="CSChatThai btncreategroup" :disabled="!(selected.length !== 0)" @click="step_creategroup = 2">{{$t('Task.allTask.next')}}</v-btn>
                  </v-flex>
                </v-layout>
              </v-stepper-content>

              <v-stepper-content step="2" style="height: 550px">
                <v-container wrap style="padding-top: 0px;padding-bottom: 10px;">
                  <h4 style="padding-left: 10px;">{{$t('AnswerQuestion.createGroup')}}</h4>
                  <v-layout row wrap>
                    <v-flex sm12 md12 lg12 xl12 style="display: flex; justify-content: center;padding-bottom: 5px;">
                      <div  class="List_item_body">
                        <div class="SettingImg">
                          <div class="SettingImgWrap">
                            <div>
                              <img src='/static/img/default_profile/group-white.png' class="alligator-turtle" style="cursor: pointer; width: 140px;height: 140px;"  v-if="imageData == ''" @click="uppic">
                              <img :src="imageData" class="alligator-turtle" @click="uppic" v-else style="cursor: pointer; width: 140px;height: 140px;" >
                              <div style="display: none;">
                                <input class="CSChatThai" type="file" name="file1" @change="previewImageweb" accept="image/*" id="uploadpicgroupweb" />
                              </div>
                              <label for="SettingImg" class="SettingImgBtn" @click="uppic()">
                                {{$t('AnswerQuestion.selectPicture')}}
                              </label>
                            </div>
                          </div>
                        </div>
                        <p class="EditAreaNote">{{$t('Settings.editProfile.support')}} .JPEG/.PNG/.GIF</p><p class="EditAreaNote"></p><p class="EditAreaNote"></p>
                      </div>
                    </v-flex>
                    <v-flex sm12 md12 lg12 xl12 class="mt-2 mr-2 ml-2">
                      <v-layout align-center justify-center fill-height row>
                        <input type="text" :placeholder="$t('LeftSide.createGroup.detailSearch')" class="CSChatThai inputgroupweb" v-model="GroupName">
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
                <v-layout row wrap style="margin-top: 170px;">
                  <v-flex class="text-xs-left">
                    <template>
                      <v-btn @click="step_creategroup = 1" class="CSChatThai btncanclegroup">{{$t('Register.Button.back')}}</v-btn>
                    </template>
                  </v-flex>
                  <v-flex class="text-xs-right">
                    <v-btn class="CSChatThai btncreategroup" :loading="loading" :disabled="!(selected.length !== 0 && GroupName !== '')" @click="submit()">{{$t('AnswerQuestion.createGroup')}}</v-btn>
                  </v-flex>
                </v-layout>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>

          <!-- <v-container wrap style="padding-top: 0px;padding-bottom: 10px;">
            <v-layout row wrap>
              <v-flex sm12 md12 lg12 xl12 style="display: flex; justify-content: center;padding-bottom: 5px;">
                <div  class="List_item_body">
                  <div class="SettingImg">
                    <div class="SettingImgWrap">
                      <div>
                        <img src='/static/img/default_profile/group-white.png' class="alligator-turtle" style="cursor: pointer; width: 140px;height: 140px;"  v-if="imageData == ''" @click="uppic">
                        <img :src="imageData" class="alligator-turtle" @click="uppic" v-else style="cursor: pointer; width: 140px;height: 140px;" >
                        <div style="display: none;">
                          <input class="CSChatThai" type="file" name="file1" @change="previewImageweb" accept="image/*" id="uploadpicgroupweb" />
                        </div>
                        <label for="SettingImg" class="SettingImgBtn" @click="uppic()">
                          {{$t('Settings.editProfile.changePictureProfile')}}
                        </label>
                      </div>
                    </div>
                  </div>
                  <p class="EditAreaNote">{{$t('Settings.editProfile.support')}} .JPEG/.PNG/.GIF</p><p class="EditAreaNote"></p><p class="EditAreaNote"></p>
                </div>
              </v-flex>
              <v-flex sm12 md12 lg12 xl12 class="mt-2 mr-2 ml-2">
                <v-layout align-center justify-center fill-height row>
                  <input type="text" :placeholder="$t('LeftSide.createGroup.detailSearch')" class="CSChatThai inputgroupweb" v-model="GroupName">
                </v-layout>
              </v-flex>
                  <v-flex sm6 md6 lg6 xl6 class="borderlistfriend">
                    <v-text-field v-model="searchfriend" solo hide-details append-icon="search" :label="$t('LeftSide.createGroup.searching')" clearable style="margin: 7px;"/>
                      <v-list class="CSChatThai widthfull scrolling-wrapper" style="padding: 0px;"  v-if="FilterFriendList.length != 0" >
                        <template v-for="(item, index) in FilterFriendList">
                          <v-list-tile :key="item.tokenuser" avatar ripple >
                            <v-list-tile-action>
                              <v-checkbox v-model="selected" :value="item" style="color: #2562af !important;">
                              </v-checkbox>
                            </v-list-tile-action>
                            <v-list-tile-avatar>
                              <img  v-if="item.profilepicture"  :src="item.profilepicture" class="alligator-turtle">
                              <img v-else-if="item.type === 'company'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                              <img v-else-if="item.type === 'government'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                              <img v-else-if="item.type === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
                              <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                              <v-list-tile-title class="textoverflow">
                                {{ item.name }}
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </template>
                      </v-list>
                  <v-container v-else>
                    <v-list>
                      <v-list-tile @click="showDialog('AddFriend')">
                        <v-list-tile-content>
                          <v-list-tile-title class="CSChatThai " style="font-size:12px;text-align:center;color: black;">
                            <v-icon style="color: black;  font-size: 18px !important;">add_circle</v-icon>
                            {{$t('AnswerQuestion.addFriend')}}
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </v-container>
                  </v-flex>
                  <v-flex sm5 md5 lg5 xl5 class="borderlistfriend" style="margin-left: 35px;">
                    <div class="setBorder ml-1">
                      <v-layout row wrap class="setPaddingButtomListFriendInGroup" style="margin-top: 5px;">
                          <h4 style="padding-left: 12px;" v-if="selected.length != 0">{{$t('LeftSide.createGroup.numberFriend',{count:selected.length})}}</h4>
                      </v-layout>
                      <div class="widthfull scrolling-wrapper" v-if="selected.length != 0">
                        <v-chip close v-for="i in selected" @input="removeListAddGroup(i)">
                          <v-avatar >
                            <img v-if="i.profilepicture" :src="i.profilepicture" :alt="i.name" class="alligator-turtle">
                            <img v-else-if="i.type === 'company'" src='/static/img/default_profile/business-white.png' :alt="i.name">
                            <img v-else-if="i.type === 'government'" src='/static/img/default_profile/business-white.png' :alt="i.name">
                            <img v-else-if="i.type === 'bot'" src='/static/img/default_profile/bot-white.png' :alt="i.name">
                            <img v-else src='/static/img/default_profile/man-white.png' :alt="i.name">
                          </v-avatar>
                          {{i.name}}
                        </v-chip>
                      </div>
                      <div v-else style="margin-top: 100px;">
                        <v-layout align-center justify-center fill-height row>
                          <h5>{{$t('LeftSide.createGroup.noneSelect')}}</h5>
                        </v-layout>
                      </div>
                    </div>
              </v-flex>
            </v-layout>
          </v-container> -->

        </v-card-text>
        <!-- <v-card-actions>
          <v-layout align-center justify-center row>
            <v-btn class="CSChatThai btncreategroup" :loading="loading" :disabled="!(selected.length !== 0 && GroupName !== '')" @click="submit()">{{$t('AnswerQuestion.createGroup')}}
          </v-btn>
            <v-btn @click.native="closeDialog" class="CSChatThai btncanclegroup">{{$t('AnswerQuestion.cancel')}} </v-btn>
          </v-layout>
        </v-card-actions> -->
      </v-card>
      <AddDialog :dialogAdd="AddFriend" v-on:closeDialogAddFriend="closeDialogAddFriend"></AddDialog>
    </v-dialog>

</template>

<script>
import AddDialog from '@/components/chat/dialog/manage_friend/AddFriendDialog'
import { sync } from 'vuex-pathify'
import { Decode } from '@/services'

export default {
  props: {'dialogGroup': false},
  data: () => ({
    loading: false,
    AddFriend: false,
    imageData: '',
    selectFile: '',
    token: '',
    selected: [],
    invites: [],
    idbusiness: [],
    GroupName: '',
    FriendList: [],
    searchfriend: '',
    listmember: [],
    step_creategroup: 1
  }),
  computed: {
    FilterFriendList () {
      if (this.searchfriend !== '' && this.searchfriend !== null) {
        return this.FriendList.filter(post => {
          return post.name.toLowerCase().includes(this.searchfriend.toLowerCase())
        })
      } else {
        return this.FriendList
      }
    },
    ...sync('*')
  },
  watch: {
    dialogGroup () {
      if (this.dialogGroup) {
        this.axios.post(process.env.APImanage + '/web/getlistfriend', {tokenuser: this.token}).then((response) => {
          // console.log(response.data)
          this.FriendList = response.data['listfriend']
          this.selected = []
        })
      }
    },
    socketaccept_friend (data) {
      // console.log(data)
      if (data.tokenuser === this.token) {
        this.axios.post(process.env.APImanage + '/getuser', {owner: this.token, tokenuser: [data.tokenfriend]}).then((response) => {
          var _ = require('lodash')
          // update list friend after accept friend
          if (_.find(this.FriendList, function (o) { return o.tokenuser === response.data.user[0].tokenuser }) === undefined) {
            this.FriendList.unshift({
              email: response.data.user[0].email,
              name: response.data.user[0].name,
              phone: response.data.user[0].phone,
              profilepicture: response.data.user[0].profilepicture,
              state: response.data.user[0].state,
              status: response.data.user[0].status,
              tokenuser: response.data.user[0].tokenuser,
              type: response.data.user[0].type,
              tokenroom: data.tokenroom
            })
            this.FriendList = _.orderBy(this.FriendList, ['name'], ['asc'])
          }
        })
      }
    }
  },
  components: {
    AddDialog
  },
  methods: {
    removeListAddGroup (item) {
      this.selected.splice(this.selected.indexOf(item), 1)
    },
    showDialog (dialog) {
      if (dialog === 'AddFriend') {
        this.AddFriend = true
      }
    },
    closeDialogAddFriend (value) {
      this.AddFriend = value
    },
    uppic () {
      $('#uploadpicgroupweb').click()
    },
    closeDialog () {
      let self = this
      this.$emit('closeDialogCreateGroup', false)
      this.invites = []
      this.idbusiness = []
      this.GroupName = ''
      this.selected = []
      self.imageData = ''
      self.selectFile = ''
      document.getElementById('uploadpicgroupweb').value = ''
      this.loading = false
    },
    previewImageweb (data) {
      var input = data.target
      this.selectFile = data.target.files[0]
      if (input.files && input.files[0]) {
        var reader = new FileReader()
        reader.onload = (e) => {
          this.imageData = e.target.result
        }
        reader.readAsDataURL(input.files[0])
      }
    },
    submit () {
      if (this.selected.length < 1) {
        this.$swal({
          title: this.$t('Alert.Fail.createGroup.title'),
          text: this.$t('Alert.Fail.createGroup.selectFriend'),
          type: 'warning',
          showCloseButton: true,
          reverseButtons: true
        })
      } else if (this.GroupName === '') {
        this.$swal({
          title: this.$t('Alert.Fail.createGroup.title'),
          text: this.$t('Alert.Fail.createGroup.groupname'),
          type: 'warning',
          showCloseButton: true,
          reverseButtons: true
        })
      } else {
        for (var i = 0; i < this.selected.length; i++) {
          this.invites[i] = this.selected[i].tokenuser
          // this.idbusiness[i] = this.selected[i].business_id
          // this.listmember[i] = {tokenuser: this.invites[i], business_id: this.idbusiness[i]}
          if (i === this.selected.length - 1) {
            this.loading = true
            // console.log(this.listmember)
            this.axios.post(process.env.APInew_creategroup, {tokenuser: this.token, listmember: this.invites, group_name: this.GroupName}).then((response) => {
              if (response.data.status === 'success') {
                // console.log(response.data)
                if (this.selectFile !== '') {
                  var uploadFile = new FormData()
                  uploadFile.append('file', this.selectFile, this.selectFile.name)
                  uploadFile.append('group_id', response.data.group.group_id)
                  uploadFile.append('tokenuser', this.token)
                  // console.log(uploadFile)
                  this.axios.post(process.env.APImanage + '/setimagegroup', uploadFile).then((responsed) => {
                    // console.log(responsed.data)
                    if (responsed.data.status === 'success') {
                      this.$swal(
                        this.$t('Alert.Success.createGroup'),
                        '',
                        'success')
                      // let self = this
                      this.selectFile = ''
                      this.imageData = ''
                      this.selected = []
                      this.closeDialog()
                      document.getElementById('uploadpicgroupweb').value = ''
                      this.$emit('updatecreategroup', response.data.group, responsed.data.filename)
                      this.$emit('updatelistchat', response.data.group, responsed.data.filename)
                      this.loading = false
                    }
                    this.$emit('closeDialogCreateGroup', false)
                  })
                } else {
                  // let self = this
                  this.$swal(
                    this.$t('Alert.Success.createGroup'),
                    '',
                    'success')
                  this.selectFile = ''
                  this.imageData = ''
                  this.selected = []
                  this.closeDialog()
                  document.getElementById('uploadpicgroupweb').value = ''
                  this.$emit('closeDialogCreateGroup', false)
                  this.$emit('updatecreategroup', response.data.group, '')
                  this.$emit('updatelistchat', response.data.group, '')
                  this.loading = false
                }
              } else {
                // console.log(response.data)
                this.loading = false
              }
            })
          }
        }
      }
    }
  },
  created () {
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
    // this.business_id = localStorage.getItem('business_id')
    // this.typeuser = localStorage.getItem('type_user')
    this.axios.post(process.env.APImanage + '/web/getlistfriend', {tokenuser: this.token}).then((response) => {
      // console.log(response.data)
      this.FriendList = response.data['listfriend']
    })
  }
}
</script>
<style scoped>
.btncreategroup {
  font-size: 13px !important;
  border-radius: 5px;
  margin-left: 0vw !important;
  margin-right: 15px!important;
  background: #2562af !important;
  color: white !important;
  text-transform: none;
}
.btncanclegroup {
  font-size: 13px !important;
  border-radius: 5px;
  margin-left: 15px !important;
  margin-right: 0vw !important;
  background: #e0e0e0 !important;
  color: black !important;
  text-transform: none;
}
>>> .v-messages {
  min-width: 1px;
  position: relative;
}
>>> .v-list__tile__action, .v-list__tile__avatar {
  display: flex;
  justify-content: flex-start;
  min-width: 40px;
}
.textoverflow {
  padding-left: 12px;
  white-space: nowrap;
  width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
}
.widthfull{
  width: 95%;
}
.heightfull {
  min-height: 100vh !important;
}
/* .scrolling-wrapper {
  height: 170px !important;
  width: 100%;
  overflow-y: scroll;
} */
.scrolling-wrapper {
  /*display: flex;*/
  height: 220px !important;
  overflow-y: auto;
}
.scrolling-wrapper::-webkit-scrollbar {
  height: 4px;
  width: 8px;
}
.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: rgba(0, 0, 0, .1);
}

.scrolling-wrapperx {
  /*display: flex;*/
  width: 95%;
  overflow-x: auto;
}
.scrolling-wrapperx::-webkit-scrollbar {
  height: 4px;
  width: 8px;
}
.scrolling-wrapperx::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: rgba(0, 0, 0, .1);
}
.borderlistfriend {
  border-radius: 4px;
  margin-top: 10px;
  border-color: #b7b7b7;
  border-style: solid;
  border-width: thin;
  height: 300px;
}
.borderlistfriendSelect {
  border-radius: 4px;
  margin-top: 10px;
  border-color: #b7b7b7;
  border-style: solid;
  border-width: thin;
  height: 100px;
}
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}
.fileInput {
  color: white;
  width: 21vw !important;
}
.inputWrapper {
    height: 32px;
    width: 70px;
    overflow: hidden;
    position: relative;
    cursor: pointer;
    margin-top: 5vh;
    /*Using a background color, but you can use a background image to represent a button*/
    /*background-color: #DDF;*/
}

.cardlist{
    padding-top: 10px;
    width: 100%;
    height: 30vh;
    overflow-x: hidden;
    overflow-y: scroll;
}

.cardlist::-webkit-scrollbar{
    width: 10px;
}

.cardlist::-webkit-scrollbar-thumb{
    border-radius: 5px;
    background: rgba(0, 0, 0, .1);
}
.alligator-turtle {

  object-fit: cover;
  object-position: 50% 0;
}
>>>.inputgroupweb {
  color: black !important;
  font-size: 16px !important;
}
input[type=text] {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #b7b7b7;
  border-radius: 30px;
  font-size: 16px;
  background-color: white;
  background-image: url('/static/img/default_profile/group-white.png');
  background-position: 10px 10px;
  background-repeat: no-repeat;
  padding: 12px 20px 12px 20px;
  -webkit-transition: width 0.4s ease-in-out;
  transition: width 0.4s ease-in-out;
}
input[type=text]:focus {
    outline: none !important;
}
>>>.v-input .v-label {
    height: 20px;
    line-height: 24px;
}
>>> .v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0px !important;
}
>>>.accent--text {
  color: #2562af !important;
  caret-color: #2562af !important;
}
>>>.v-text-field.v-text-field--enclosed .v-input__slot, .v-text-field.v-text-field--enclosed .v-text-field__details {
    padding: 0 12px;
    box-shadow: none !important;
    border: #b7b7b7 1px solid;
    border-radius: 40px;
    background-color: white;
}
.SettingImgWrap {
  display: inline-block;
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  margin-top: 20px;
}
.SettingImgBtn {
    display: block;
    overflow: hidden;
    position: absolute;
    bottom: -20px;
    right: -20px;
    line-height: 1;
    width: 40px;
    height: 30px;
    bottom: 0;
    left: 0;
    line-height: 30px;
    width: 100%;
    text-align: center;
    cursor: pointer;
    color: #fff;
    background: rgba(0, 0, 0, .5);
}

.SettingImgBtn:hover {
  display: block;
  overflow: hidden;
  position: absolute;
  bottom: -20px;
  right: -20px;
  line-height: 1;
  width: 40px;
  height: 50%;
  bottom: 0;
  left: 0;
  line-height: 30px;
  width: 100%;
  text-align: center;
  cursor: pointer;
  color: #fff;
  background: rgba(0, 0, 0, .75);
}
.EditAreaNote {
  margin: 8px 0 0;
  font-size: 13px;
  color: #BEC8D2;
  font-size: 12px;
}
>>> .v-item-group {
  width: max-content;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/dialog/manage_group/CreateGroupDialog.vue